var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.772209 10.5301C0.708937 10.5933 0.666369 10.6738 0.648315 10.7606L0.00880433 13.9593C-0.0210097 14.1076 0.0260302 14.2605 0.132698 14.3681C0.218662 14.4541 0.33444 14.5001 0.453033 14.5001C0.481854 14.5001 0.511833 14.4975 0.541647 14.4912L3.73937 13.8517C3.82798 13.8335 3.90848 13.7911 3.97092 13.7276L11.1279 6.5706L7.93023 3.37305L0.772209 10.5301Z",
    fill: "#032339"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3363 1.1615C12.4545 0.2795 11.0197 0.2795 10.1386 1.1615L8.88672 2.41336L12.0844 5.61108L13.3363 4.35905C13.7633 3.93304 13.9985 3.36492 13.9985 2.76069C13.9985 2.15646 13.7633 1.58834 13.3363 1.1615Z",
    fill: "#032339"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpen);
export default __webpack_public_path__ + "static/media/editpen.30e27408a1c5066f41db7aeafedc6364.svg";
export { ForwardRef as ReactComponent };